import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    section: {
      marginTop: theme.spacing(12),
    },
    sectionTitle: {
      marginBottom: theme.spacing(8),
      color: theme.gray800,
      fontSize: 16,
      fontWeight: 500,
    },
    tooltipTitle: {
      color: theme.primary800,
      fontSize: 14,
      fontWeight: 500,
      marginBottom: theme.spacing(2),
      lineHeight: "24px",
    },
    tooltipDesc: {
      color: theme.gray500,
      fontSize: 12,
      fontWeight: 400,
    },
    tootlipWrapper: {
      display: "flex",
      alignItems: "center",

      "& svg": {
        color: theme.gray500,
        height: "16px",
        marginLeft: theme.spacing(2),
        width: "16px",
      },
    },
    content: {
      marginTop: theme.spacing(12),
    },
  }),
);
